<template>
<div class="chapter">
<div class="inner_page">
<p class="decication"><a id="dedication"></a><a id="page_vii"></a>His heart,<br/>
  in childhood, always delighted<br/>
  in every leaf, every slice of sky,<br/>
  contemplating his village. This future<br/>
  was unaware that today<br/>
  the horizon aligns itself with other<br/>
  indifferences. Everything has happened:<br/>
  in us, by fate,<br/>
  we are prisoners of regret<br/>
  for our innocence.</p>
<p class="att">—Pier Paolo Pasolini, “Europa”<a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4730d064